import { Controller, useFormContext } from 'react-hook-form';
import { Box, Button, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useMemo, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { DynDadosCadastraisProps } from '..';
import DialogAddEditDadoSocio from './DialogAddEditDadoSocio';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default function DadosSociedade({ spec, extras }: DynDadosCadastraisProps) {
    const { control, watch, getValues, setValue } = useFormContext();

    const [openSociedadeModal, setOpenSociedadeModal] = useState<TOpenModalDadosSocio>({ open: false });

    const possuiSociedade = watch(`${spec.name}.possui_sociedade`) === "Sim"
    const sociedades = watch(`${spec.name}.sociedades`) || [];
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 };

    const opcoesRadio = useMemo(() => [
        { value: "Sim", label: "Sim" },
        { value: "Não", label: "Não" },
    ], [])
    return (
        <>
            <Grid container size={{ xs: 12 }} spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <Typography fontWeight={'bold'} variant='h6'>Dados do(s) Sócio(s)</Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Controller
                        name={`${spec.name}.possui_sociedade`}
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <FormControl {...field}>
                                <FormLabel id="possui_sociedade">Possui sociedade?</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="Possui sociedade?"
                                    value={getValues(`${spec.name}.possui_sociedade`)}
                                    onChange={(e) => field.onChange(e.target.checked)}
                                >
                                    {
                                        opcoesRadio.map((opcao, index) => (
                                            <FormControlLabel key={index} value={opcao.value} control={<Radio />} label={opcao.label} />
                                        ))
                                    }
                                </RadioGroup>
                                <FormHelperText error>{error ? error.message : ""}</FormHelperText>
                            </FormControl>
                        )}
                    />
                </Grid>
                {
                    possuiSociedade && sociedades.length > 0 &&
                    <>
                        <Grid size={{ xs: 12 }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={paddingStyle}>
                                                <b>Nome/CNPJ</b>
                                            </TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sociedades.map((item: IDadosSocio, index: number) => (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <Controller
                                                    name={`${spec.name}.sociedades[${index}]`}
                                                    control={control}
                                                    rules={{ required: "Campo obrigatório" }}
                                                    render={({ field, fieldState: { error, invalid } }) => (
                                                        <TableCell sx={{ ...paddingStyle, color: invalid ? 'red' : 'inherit' }}>
                                                            {item.nome || item.cnpj} {invalid && "Campo obrigatório"}
                                                        </TableCell>
                                                    )}
                                                />
                                                <TableCell sx={paddingStyle}>
                                                    <Box
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="flex-end"
                                                    >
                                                        <IconButton
                                                            aria-label="edit"
                                                            onClick={() => {
                                                                setOpenSociedadeModal({ open: true, index });
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            aria-label="delete"
                                                            onClick={() => {
                                                                const novasSociedades = sociedades.filter((_: any, i: number) => i !== index);
                                                                setValue(`${spec.name}.sociedades`, novasSociedades);
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </>
                }
                {
                    possuiSociedade &&
                    <Grid size={{ xs: 12 }}>
                        <Controller
                            name={`${spec.name}.sociedades`}
                            control={control}
                            rules={{ required: "Campo obrigatório" }}
                            render={({ field, fieldState: { error, invalid } }) => (
                                <>
                                    <Button
                                        variant="outlined"
                                        color={error ? 'error' : 'primary'}
                                        startIcon={<AddIcon />}
                                        onClick={() => setOpenSociedadeModal({ open: true })}
                                    >
                                        Adicionar Sócio
                                    </Button>
                                    <FormHelperText error>{invalid && error ? error.message : ""}</FormHelperText>
                                </>
                            )}
                        />

                    </Grid>
                }
            </Grid>
            {
                openSociedadeModal.open &&
                <DialogAddEditDadoSocio
                    open={openSociedadeModal.open}
                    onClose={() => setOpenSociedadeModal({ open: false })}
                    index={openSociedadeModal.index}
                />
            }
        </>
    )
}

export type TOpenModalDadosSocio = {
    open: boolean;
    index?: number;
}

export interface IDadosSocio {
    tipo_socio: "F" | "J";
    nome?: string;
    nome_social?: string;
    rg?: string;
    cpf?: string;
    sexo?: "M" | "F";
    data_nascimento?: string;
    nacionalidade?: string;
    cnpj?: string;
}
